let view = null;

export default {
	namespace: 'template-tools',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: ToolsView } = await import(/* webpackChunkName: "tools-view" */ '../../templates/ToolsView');
		view = new ToolsView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
